import { apiDelete, apiGet, apiPost, apiPut } from './apiClient';

export type FreebieSummaryDto = {
  id: string;
  publicToken: string;
  title: string;
  isActive: boolean;
  downloadCount: number;
  createdAt: string;
};

export type FreebieDto = FreebieSummaryDto & {
  description?: string;
  fileUrl: string;
  fileName: string;
  fileMimeType?: string;
  fileSizeBytes?: number;
  requireEmail: boolean;
  allowMultipleDownloadsPerEmail: boolean;
  maxDownloads?: number;
  availableFrom?: string;
  availableUntil?: string;
};

export type FreebieDownloadDto = {
  id: string;
  email: string;
  emailNormalized: string;
  createdAt: string;
  downloadedAt?: string | null;
  marketingConsent: boolean;
  ipAddress?: string | null;
  userAgent?: string | null;
  downloadToken: string;
};

export type CreateFreebieDto = Omit<FreebieDto, 'id' | 'publicToken' | 'downloadCount' | 'createdAt'>;

export const FreebieService = {
  getAll: async (): Promise<FreebieSummaryDto[]> => apiGet<FreebieSummaryDto[]>('/api/admin/freebies'),
  getById: async (id: string): Promise<FreebieDto> => apiGet<FreebieDto>(`/api/admin/freebies/${id}`),
  getDownloads: async (id: string): Promise<FreebieDownloadDto[]> => apiGet<FreebieDownloadDto[]>(`/api/admin/freebies/${id}/downloads`),
  create: async (dto: CreateFreebieDto): Promise<{ message: string }> => apiPost('/api/admin/freebies', dto),
  update: async (id: string, dto: CreateFreebieDto): Promise<{ message: string }> =>
    apiPut(`/api/admin/freebies/${id}`, dto),
  delete: async (id: string): Promise<{ message: string }> => apiDelete(`/api/admin/freebies/${id}`),
};
